import React from 'react';
import PropTypes from 'prop-types';
var SvgContextMixin = require('./svgContextMixin');

var ChartLabel = React.createClass({

  statics: {
    textHeightRate: 0.8
  },

  mixins: [SvgContextMixin],

  propTypes: {
    text: PropTypes.string
  },

  render(){
    var {text} = this.props;
    if (!text) return null;

    return (
      <text
        x={this._x()}
        y={this._y()}
        dy="0.35em"
        textAnchor="middle"
        fontFamily={this._font()}
        fontSize={this._fontSize()}>
        {text}
      </text>
    );
  },

  _x(){
    var {box} = this.props;
    return this.context.relativeX(box[2]) / 2 + this.context.relativeX(box[0]);
  },

  _y(){
    var {box} = this.props;
    return this.context.relativeY(box[3]) / 2 + this.context.relativeY(box[1]);
  },

  _fontSize(){
    var current = this.context.relative(this.context.height, this.props.box[3]) * ChartLabel.textHeightRate;
    return this.context.getFontSize(current);
  },

  _font(){
    return this.context.font;
  }

});

module.exports = ChartLabel;
